export const OverrideWidgetsProperties = function (appModel, userModel) {
  if (!appModel || !userModel) {
    return
  }
  for (let moduleIndex in userModel.Modules) {
    let overrides = userModel.Modules?.[moduleIndex]?.WidgetPropertiesOverrides
    if (!overrides) {
      continue
    }
    for (let widgetIndex in overrides) {
      let widget = overrides[widgetIndex]
      let foundWidget = findWidgetById(appModel, widget?.$ID)
      if (!foundWidget) {
        continue
      }
      for (let prop in widget) {
        foundWidget[prop] = widget[prop]
      }
    }
  }
}

export function findWidgetById(target, widgetId) {
  if (!widgetId) {
    return undefined
  }
  for (let key in target) {
    if (target[key]?.['$ID'] == widgetId) {
      return target[key]
    }
  }
  for (let key in target) {
    if (typeof(target[key]) == 'object') {
      let widget = findWidgetById(target[key], widgetId)
      if (widget) {
        return widget
      }
    }

  }
}